<template>
  <transition name="modal">
    <div class="modalMask" v-show="show" @click.stop="handleClick">
      <div class="modalWrapper">
        <div class="modalContainer" @click.stop>
          <div class="modalHeader">
            <slot name="header"> </slot>
          </div>
          <div class="modalBody">
            <slot name="body"> </slot>
          </div>
          <div class="modalFooter">
            <slot name="footer"> </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleClick() {
      if (this.isConfirmOpen) {
        if (typeof this.closeCallback === 'function') this.closeCallback();
      } else if (typeof this.callback === 'function') {
        this.callback();
      }
      this.closeModal();
    },
  },
  computed: {
    ...mapGetters('modal', ['isConfirmOpen', 'callback', 'closeCallback']),
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
